// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3x-jD","rootSmall":"AddTileButton_rootSmall__Sabjs"};